import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getWorkDateOptions = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/monitoring-host/work-dates/list' });

  return data?.data;
};

export default getWorkDateOptions;
